import store from '../store'

export let storeInserter = {
    store,
    install(Vue, options) {
        Vue.prototype.$Store = store
    }
}

export let customFunctions = {
    methods: {
      decodeHtml(html) {

        let txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
      },
        // sendForm: function (data) {
        //     let $submit = jQuery('#submitbutton');
        //     $submit.prop("disabled", true)
        //     setTimeout(function () {
        //         $submit.prop("disabled", false)
        //     }, 2000)
        //     let strippeddata = JSON.parse(JSON.stringify(data))
        //
        //     let url = process.env.NODE_ENV === 'development' ? 'http://friedl.zz.local/mailanfrage' : '/mailanfrage'
        //     jQuery.ajax({
        //         url: url,
        //         type: 'post',
        //         data: strippeddata,
        //         error: function () {
        //             this.errorsent = true
        //         }.bind(this)
        //     })
        //         .done(function (val) {
        //             try {
        //                 if (JSON.parse(val).success) this.justsent = true;
        //                 else this.errorsent = true;
        //             }
        //             catch (e) {
        //                 console.log(e)
        //                 this.errorsent = true
        //             }
        //         }.bind(this))
        //
        // },
        sendForm: function (data) {
            let $submit = jQuery('#submitbutton');
            $submit.prop("disabled",true)
            setTimeout(function(){
                $submit.prop("disabled",false)
            },2000)
            let strippeddata = JSON.parse(JSON.stringify(data))

            let url = process.env.NODE_ENV==='development'?'http://friedl.zz.local/mailanfrage':'/mailanfrage'
            jQuery.ajax({
                url: url,
                type: 'post',
                data: strippeddata,
                error: function () {
                    this.errorsent = true
                }.bind(this)
            })
                .done(function (val) {
                    try {
                        if (JSON.parse(val).success) this.justsent = true;
                        else this.errorsent = true;
                    }
                    catch (e){
                        console.log(e)
                        this.errorsent = true
                    }
                }.bind(this))

        },
        goTo(target) {

            this.$SmoothScroll(
                this.getPosition(target).offset - 110
                , 1000
            )
        },
        getPosition(id) {
            let el = document.getElementById(id)
            let top = 0
            if (el) {
                top = el.getBoundingClientRect().top;
            }
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let height = 0

            if (jQuery(el).parent().length > 0) {
                height = jQuery(el).parent().css('height').replace('px', '')
            }
            return {'top': top, 'height': height, 'offset': scrollTop + top}
        },
        shortLink: function (link) {
            return link.replace(/^.*\/\/[^\/]+/, '');
        },
        scrollToTop() {
            jQuery('html,body').animate({scrollTop: 0}, 500);
        },
        chunkArray(arr, chunk_size) {
            let index = 0;
            let chunks = [];
            if (arr) {

                for (index = 0; index < arr.length; index += chunk_size) {
                    let myChunk = arr.slice(index, index + chunk_size);
                    // Do something if you want with the group
                    chunks.push(myChunk);
                }
            }
            return chunks;
        },
        getBackground(img) {
            return "url('" + img + "')"
        },
        getFeatured(page, size) {
            if (size!=='') {
                return page['_embedded']['wp:featuredmedia'] ? page['_embedded']['wp:featuredmedia'][0].source_url : false;
            }
            else {
                return page['_embedded']['wp:featuredmedia'] ? page['_embedded']['wp:featuredmedia'][0]['media_details']['sizes'][size].source_url : false
            }

        },
    },
    directives: {
        squared: {
            inserted(el, binding) {
                let factor = binding.value !== undefined ? binding.value : 1;
                let width = jQuery(el).width();
                jQuery(el).css('height', width / factor)
            }
        }
    },
    computed: {
        sliderheight() {
            if (store.state.page) {
                return store.state.page.acf ? store.state.page.acf.height : []
            }
            else return '100'
        }
    }
}

export let connectionCheck = {
    data() {
        return {
            offline: false
        }
    },
    created() {
        window.addEventListener('online', this.networkChange)
        window.addEventListener('offline', this.networkChange)
    },
    methods: {
        networkChange(e) {
            this.offline = e.type == "offline";
        }
    }
}

export let resizeHandler = {
    data() {
        return {
            scrHeight: 0,
            windowWidth: 0
        }
    },
    methods: {
        getHeight: function () {
            this.scrHeight = window.innerHeight
            this.windowWidth = jQuery(window).width()
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.getHeight);
    },
    created: function () {
        this.getHeight()
        window.addEventListener('resize', this.getHeight, {passive: true})
    },

}

export let scrollHandler = {
    data: function () {
        return {
            scrollPosition: 0,
        }
    },
    components: {},
    methods: {
        handleScroll: function () {
            window.requestAnimationFrame(function () {
                this.scrollPosition = window.scrollY || window.pageYOffset;
            }.bind(this))
        },
        focusMessage: function () {
            jQuery('#message').focus()
        }
    },
    destroyed() {
        window.removeEventListener('DOMContentLoaded', this.handleScroll);
    },
    created: function () {
        window.addEventListener('scroll', this.handleScroll, {passive: true});
    },
    watch: {}
}



// WEBPACK FOOTER //
// ./src/mixins/index.js